import { routes } from "../routes";
import { userRoute } from "./user-route";

export const guards = {
    [routes.index]: userRoute(),
}
